import React from "react";
import { BookOpenIcon, GiftIcon, GlobeIcon, CheckIcon, TrophyIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { images } from "../data/content";
const perks = ["One-time payment", "Lifetime access", "No monthly subscription", "Instant access"];
export function OfferSection() {
  return <section id="offer" className="bg-wine-900 px-4 py-16 sm:py-24" aria-labelledby="offer-title" data-id="element-166" data-mp="idzux0w5322o">
      <div className="mx-auto max-w-2xl" data-id="element-167" data-mp="me1zpix68bm6">
        <div className="flex justify-center" data-id="element-168" data-mp="mgwkxco0e0gn">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-2 text-sm font-extrabold uppercase text-wine-950" data-id="element-169" data-mp="rdej1tou30k0">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-170" data-mp="wchjf0tvciln" /> Special launch offer
          </span>
        </div>
        <h2 id="offer-title" className="mt-5 text-center font-serif text-3xl font-bold leading-tight text-white sm:text-5xl" data-id="element-171" data-mp="2t7dxup16001g">
          Here's everything you'll receive <em className="text-wine-200" data-id="element-172" data-mp="12ojy0hic0coe">today</em>
        </h2>

        <div className="mt-10 rounded-[28px] bg-white p-5 shadow-2xl sm:p-8" data-id="element-173" data-mp="xws4by3vpqu1">
          <img src={images.product} alt="Biomechanics War Room™ complete bundle" className="mx-auto w-full" data-id="element-174" data-mp="xupaf2zlvdk1" />

          <ul className="mt-4 divide-y divide-wine-100 rounded-2xl bg-cream px-4" data-id="element-175" data-mp="ow3sna1yk2kb">
            <li className="flex items-center justify-between gap-3 py-4" data-id="element-176" data-mp="ou0ug2qnj34i">
              <span className="flex items-center gap-3 font-semibold text-ink" data-id="element-177" data-mp="1llumr86c7npl">
                <BookOpenIcon className="h-5 w-5 shrink-0 text-wine-700" aria-hidden="true" data-id="element-178" data-mp="1gococbpy4qvu" />
                Biomechanics War Room™ — 6 premium volumes
              </span>
              <span className="shrink-0 font-bold text-ink-soft line-through" data-id="element-179" data-mp="17mv6ooww4h51">$97</span>
            </li>
            <li className="flex items-center justify-between gap-3 py-4" data-id="element-180" data-mp="172f58e9q186">
              <span className="flex items-center gap-3 font-semibold text-ink" data-id="element-181" data-mp="146jxrtt1qnf">
                <GiftIcon className="h-5 w-5 shrink-0 text-wine-700" aria-hidden="true" data-id="element-182" data-mp="3sex33dzfwba9" />
                5 exclusive bonuses
              </span>
              <span className="shrink-0 font-bold text-ink-soft line-through" data-id="element-183" data-mp="2o81l8gcr00v">$197</span>
            </li>
            <li className="flex items-center justify-between gap-3 py-4" data-id="element-184" data-mp="3ku2wfnd8ifjn">
              <span className="text-sm font-bold uppercase tracking-wide text-ink" data-id="element-185" data-mp="3oumuct5mtn6u">Total reference value</span>
              <span className="shrink-0 text-lg font-extrabold text-red-600 line-through" data-id="element-186" data-mp="3b2zy2tboweo2">$294</span>
            </li>
          </ul>

          <div className="mt-8 text-center" data-id="element-187" data-mp="3fv02oz2pfvqz">
            <p className="text-base font-semibold text-ink-soft" data-id="element-188" data-mp="315c2k169f34u">Today you can get full access for just…</p>
            <p className="mt-1 font-serif text-[88px] font-extrabold leading-none text-wine-700 sm:text-[110px]" data-id="element-189" data-mp="3645h7wxa906l">
              <span className="align-top text-4xl sm:text-5xl" data-id="element-190" data-mp="2s446lpr7uedx">$</span>27
            </p>
            <p className="mt-1 text-sm font-bold uppercase tracking-wider text-ink" data-id="element-191" data-mp="2x3h18wobwpr2">USD · One-time payment</p>
          </div>

          <ul className="mt-6 grid grid-cols-2 gap-2.5" data-id="element-192" data-mp="2dj01ndja3k5e">
            {perks.map(p => <li key={p} className="flex items-center gap-2 rounded-xl bg-green-50 px-3 py-2.5 text-sm font-semibold text-green-900" data-id="element-193" data-mp="28jnhx1npet71">
                <CheckIcon className="h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-194" data-mp="2mjy7809d7zq3" />
                {p}
              </li>)}
          </ul>

          <p className="mt-6 text-center text-[16px] leading-relaxed text-ink-soft" data-id="element-195" data-mp="2wfrh1bvp9f46">
            For less than the cost of a typical textbook chapter, you'll have a complete case-based training system to practice analyzing complex biomechanical scenarios.
          </p>

          <div className="mt-6" data-id="element-196" data-mp="317rodpe3naas">
            <ScarcityBar data-id="element-197" data-mp="318ucxqny90nj" />
          </div>

          <div className="mt-6" data-id="element-198" data-mp="319vqc1sftz8f">
            <CtaButton label="Yes — I want Biomechanics War Room™" note="One-time payment of $27 · Instant access · 7-Day Guarantee" data-id="element-199" data-mp="3f6r8cjqo310m" />
          </div>
          <Countdown data-id="element-200" data-mp="3a64o7c0ropsg" />

          <p className="mt-6 flex items-start justify-center gap-2 rounded-xl bg-wine-50 px-4 py-3 text-center text-sm font-medium text-wine-900" data-id="element-201" data-mp="18j1rltxk6p8j">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-202" data-mp="1dgtufizqrvri" />
            Automatic currency conversion: the price will be shown in your local currency according to your country.
          </p>
        </div>
      </div>
    </section>;
}